export function mapModules(modules, api) {
  return Object.entries(modules).reduce((prev, entry) => {
    prev[entry[0]] = entry[1](api)
    return prev
  }, {})
}
